import React, { useState } from "react";
import "./achievements.css";
import "../../page_content.css";

const Achievements = () => {
  const [activeTab, setActiveTab] = useState("faculty");

  // Faculty Data (using cards)
  const facultyAchievements = [
    {
      img: "/assets/images/achievement/sunil_chavale.webp",
      name: "Prof. Sunil Chawale",
      mainText:
        "Prof. Sunil Chawale has demonstrated exceptional endurance and determination through his numerous marathon achievements:",
      list: [
        "42 km Tata Mumbai Marathon – Completed 7 times",
        "21 km Marathons (including Ultramarathons & Hill Marathons) – Completed 25 times",
        "10 km Marathons – Completed 55 times",
      ],
      desc: "His unwavering perseverance and commitment to fitness truly embody the spirit of endurance. Prof. Chawale serves as an inspiration to both colleagues and students, motivating everyone to strive for excellence in every sphere of life.",
    },
    {
      img: "/assets/images/achievement/Archana Bhange.webp",
      name: "Prof. Archana Bhange",
      mainText:
        "Completed Ph.D. in 'Mathematics' in December 2021 from MIT ADT University, Pune. The topic of research was 'Perfect Coloring of Graph and Related Aspects'. She has presented 10 papers at national and international conferences. Her 5 papers are published in SCOPUS indexed journals and one in UGC listed journal. Her chapter titled 'Relation between Perfect Coloring and Chromatic Number for Snake Graph Family' was published in Springer (2021). She has successfully completed a refresher course in Mathematics organized by Ramanujan College, Delhi, and received a silver medal in Graph Theory (NPTEL, 2018).",
    },
    {
      img: "/assets/images/achievement/Vrushali Rampure.webp",
      name: "Prof. Vrushali Rampure",
      mainText:
        "Completed Ph.D. in 'Electronics and Communications' in April 2022 from MIT ADT University, Pune. Her subject area is Electronics, Image Processing, and Deep Learning. A copyright is registered on her name for her literary work 'Wireless Capsule Endoscopy Video Summarization Using Transfer Learning' (Registration No. L-103417/2021).",
    },
  ];

  return (
    <div>
      <h1 className="title">Achievements</h1>
      <hr />
      {/* Buttons */}
      <div className="page-content-btns">
        <button
          className={`page-content-btn ${activeTab === "faculty" ? "active" : ""
            }`}
          onClick={() => setActiveTab("faculty")}
        >
          Faculty Achievements
        </button>

        <button
          className={`page-content-btn ${activeTab === "student" ? "active" : ""
            }`}
          onClick={() => setActiveTab("student")}
        >
          Student Achievements
        </button>
      </div>

      <div className="achievement-section">
        {/* Faculty Achievements */}
        {activeTab === "faculty" && (
          <div className="faculty-ach-cards">
            {facultyAchievements.map((item, index) => (
              <div className="faculty-ach-card" key={index}>
                {/* Header → Image + Name */}
                <div className="faculty-ach-header">
                  {item.img && (
                    <img
                      src={item.img}
                      alt={item.name}
                      className="faculty-ach-photo"
                    />
                  )}

                  {item.name && <h2 className="ach-name">{item.name}</h2>}
                </div>

                {/* Content Below */}
                <div className="faculty-ach-info">
                  {item.mainText && <p>{item.mainText}</p>}

                  {item.list && (
                    <ul className="page-content-lists">
                      {item.list.map((point, i) => (
                        <li key={i}>{point}</li>
                      ))}
                    </ul>
                  )}

                  {item.desc && (
                    <p className="faculty-description">{item.desc}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Student Achievements */}
        {activeTab === "student" && (
          <div className="student-achievement">
            {/* Achievements 1 */}
            <div className="student-ach-section">
              <div className="student-ach-card">
                <img
                  className="std-ach-img"
                  src="/assets/images/achievement/Cdt.Atharv Ghate_Cycling.webp"
                  alt="achievement"
                />
                <div className="std-ach-details">
                  <h2 className="ach-name">Cdt. Atharva Ghate</h2>
                  <h4 className="innerpage-subheading">Achievement : </h4>
                  <p>
                    Gold Medal in 10K Timed Cyclothon at National Maritime
                    Games-2025
                  </p>
                  <ul className="page-content-lists">
                    <li>Event: 10K Timed Cyclothon</li>
                    <li>Competition: National Maritime Games 2025</li>
                    <li>Venue: Mumbai, 2025</li>
                  </ul>

                  <h4 className="innerpage-subheading">Trip Summary:</h4>
                  <ul className="page-content-lists">
                    <li>Start Location: Borivali, Mumbai</li>
                    <li>Destination: Statue of Unity, Gujarat</li>
                    <li>Distance Covered: 442.7 km</li>
                    <li>Duration: 18 hours of riding</li>
                    <li>Date: 25/01/2024 - 27/01/2024</li>
                  </ul>
                </div>
              </div>


              <div className="student-ach-card">
                <img
                  className="std-ach-img"
                  src="/assets/images/achievement/Cdt.Atharv Ghate_Cycling_2.webp"
                  alt="achievement"
                />
                <div className="std-ach-details">
                  <h4 className="innerpage-subheading">
                    Achievement Summary:{" "}
                  </h4>
                  <p>
                    Representing MANET Pune. Cat. Atharv Ghate secured the Gold
                    Medal in the 10K Timed Cyclothon at the National Maritime
                    Games 2025. Competing against participants from various
                    maritime institutions across the country, they completed the
                    10 km track in a record time of 19 minutes and 15 seconds,
                    maintaining an average speed of 31.1 km/hr. This remarkable
                    achievement highlights the student's dedication to fitness,
                    sportsmanship, and the holistic development encouraged at
                    MANET, Pune.
                  </p>
                </div>
              </div>
            </div>

            {/* Achievements 2 */}
            <div className="student-ach-section">
              <div className="student-ach-card">
                <img
                  className="std-ach-img"
                  src="/assets/images/achievement/Cdt.Gaurav_Kumar_Rowing_2.webp"
                  alt="achievement"
                />
                <div className="std-ach-details">
                  <h2 className="ach-name">Cdt. Gaurav Kumar</h2>
                  <h4 className="innerpage-subheading">Achievement :</h4>
                  <p>
                    Gold Medal in 1000-meterRowing at National Maritime
                    Games-2025
                  </p>
                  <ul className="page-content-lists">
                    <li>Event: 1000-meter Rowing</li>
                    <li>Competition: National Maritime Games 2025</li>
                    <li>Venue: IMU, Navi Mumbai</li>
                    <li>Date: April 2, 2025</li>
                  </ul>
                </div>
              </div>

              <div className="student-ach-card">
                <img
                  className="std-ach-img"
                  src="/assets/images/achievement/Cdt.Gaurav_Kumar_1.webp"
                  alt="achievement"
                />
                <div className="std-ach-details">
                  <h4 className="innerpage-subheading">
                    Achievement Summary:{" "}
                  </h4>
                  <p>
                    Cát. Gaurav Kumar proudly represented MANET, Pune at the
                    National Maritime Games 2025 held at IMU, Navi Mumbai, and
                    secured the Gold Medal in the 1000-meter rowing event with a
                    completion time of 3 minutes and 18 seconds.This victory was
                    a result of rigorous training, teamwork, and determination.
                    Competing against top rowers from maritime institutes across
                    the country, the student demonstrated exceptional discipline
                    and sportsmanship. The achievement brings immense pride to
                    MANET Pune and stands as a testament to the institute's
                    emphasis on fitness, teamwork, and excellence
                  </p>
                </div>
              </div>
            </div>


            {/* Achievements 3 */}
            <div className="student-ach-section">
              <img
                className="std-ach-img"
                src="/assets/images/achievement/_MG_7121.webp"
                alt="achievement"
              />
              <img
                className="std-ach-img"
                src="/assets/images/achievement/_MG_7661.webp"
                alt="achievement"
              />
              <div className="std-ach-details">
                <h2 className="ach-name">Cdt. Saee Shinde, Cdt. Jaykumar divate and Cdt. Avlon bonny Nagorama</h2>
                <h4 className="innerpage-subheading">Achievement :</h4>
                <p>
                  Best in Theme Prize
                </p>
                <p>Representing MANET, Pune, Cdt.Saee Shinde, Cdt. Jaykumar divate and Cdt. Avlon Nagorama have won “Best in Theme” Prize in TRANSTECH-26 event organized by Tolani Maritime Institute, Induri, Pune. TRANSTECH presents a common platform for engineering students to present technical papers on varied topics of interest. It encourages the young generation of engineers to delve into numerous activities such as paper presentation and research work, thereby empowering them with a razor-sharp thinking ability. </p>
              </div>
            </div>


            {/* Achievements 4*/}
            <div className="student-ach-section" >
              <img
                className="std-ach-img"
                src="/assets/images/achievement/Aryan.webp"
                alt="achievement"
              />
              <img
                className="std-ach-img"
                src="/assets/images/achievement/Harman.webp"
                alt="achievement"
              />
              <div className="std-ach-details">
                <h2 className="ach-name">Cdt Aryan More (B. Tech Marine Engineering) and Cdt Harmandeep Kaur (B.Sc. Nautical Science)</h2>
                <h4 className="innerpage-subheading">Achievement :</h4>
                <p>
                  MASSA Excellence Award-2025
                </p>
                <p>Cdt. Aryan More (B. Tech Marine Engineering) and Cdt. Harmandeep Kaur (B.Sc. Nautical Science) have brought great pride to MANET, MIT ADT University by receiving the prestigious MASSA Excellence Award 2025. Conferred by the Maritime Association of Shipowners, Ship managers and Agents (MASSA), this honor recognizes their exceptional dedication, performance, and contribution to the maritime field. Both cadets were also awarded a cash prize of ₹50,000 each. Their success stands as an inspiration to fellow cadets, exemplifying how perseverance, discipline, and commitment to excellence lead to remarkable accomplishments.</p>
              </div>


            </div>

            {/* Achievements 5 */}
            <div className="student-ach-section" >
              <img
                className="std-ach-img"
                src="/assets/images/achievement/nautica_2.webp"
                alt="achievement"
              />
              <img
                className="std-ach-img"
                src="/assets/images/achievement/nautica_3.webp"
                alt="achievement"
              />
              <div className="std-ach-details">
                <h2 className="ach-name">Naughtica-2026</h2>
                <p>The Maharashtra Academy of Naval Education and Training (MANET) has achieved a remarkable milestone by securing the top position at the prestigious Naughtica event, competing against 24 leading institutions from across India.</p>
                <p>
                  This outstanding accomplishment is a testament to the excellence, dedication, and competitive spirit that define MANET.
                </p>
                <div style={{ display: "flex", gap: "50px" }}>

                  <div>
                    <h4 className="innerpage-subheading">Achievement :</h4>
                    <ul className="page-content-lists">
                      <li>2 Gold Medals</li>
                      <li>1 Silver Medal</li>
                      <li>Total Points: 13</li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="innerpage-subheading">Category-wise Performance :</h4>
                    <ul className="page-content-lists">
                      <li>Rowing: 5 points</li>
                      <li>Nautical Skills: 5 points</li>
                      <li>Tech Skills: 3 points</li>
                    </ul>
                  </div>

                </div>

              </div>
              <img
                className="std-ach-img"
                src="/assets/images/achievement/nautica_5.webp"
                alt="achievement"
              />
              <img
                className="std-ach-img"
                src="/assets/images/achievement/nautica_6.webp"
                alt="achievement"
              />
              <p>This historic victory highlights the unwavering commitment, discipline, and teamwork of our cadets. Their relentless efforts and passion for excellence have brought great pride to the institution. MANET continues to uphold its legacy of nurturing talent and fostering all-round development, both on and off the field.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Achievements;
